import {useEffect, useLayoutEffect} from 'react';

/**
 * Works like `useLayoutEffect` in the browser, but will not throw warnings on the server.
 */
export const useIsomorphicLayoutEffect: typeof useLayoutEffect = process.browser
  ? useLayoutEffect
  : useEffect;
